import React, { Suspense, lazy, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home = lazy(() => import("../pages/KMC/Home/index"));
const PaymentSummary = lazy(() => import("../pages/KMC/PaymentSummary/PaymentSummary"));
const Assessment = lazy(() => import("../pages/KMC/Assessment/Assessment"));
const NocCertificateAssessment = lazy(() => import("../pages/KMC/NocCertificate/NocCertificate"));
const ExpiredPage = lazy(() => import("../pages/KMC/ExpiredPage/ExpiredPage"));
const SessionWrapper = lazy(() => import("../pages/KMC/ExpiredPage/SessionWrapper"));
const NotFound = lazy(() => import("../pages/KMC/PageNotFound/NotFound"));
const WaterTaxService = lazy(() => import("../pages/KMC/WaterTaxService/index"));
const WaterPaymentSummay = lazy(() => import("../pages/KMC/WaterTaxService/WaterPaymentSummay"));
const LicenseFeePayment = lazy(() => import("../pages/KMC/LicenseFeePayment/index"));
const LicenseFeePaymentSummay = lazy(() => import("../pages/KMC/LicenseFeePayment/LicenseFeePaymentSummay"));
const GeneralDemandService = lazy(() => import("../pages/KMC/GeneralDemandService/index"));
const GeneralDemandServicePaymentSummay =  lazy(() => import("../pages/KMC/GeneralDemandService/GeneralDemandServicePaymentSummay"));
const GrievanceStatus = lazy(() => import("../pages/KMC/Grievance/GrievanceStatus"));
const RegisterGrievance = lazy(() => import("../pages/KMC/Grievance/RegisterGrievance"));
const KMCRoutes = () => {
  const { checksum } = useSelector((state) => state.culturalHeritageReducer);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (checksum?.acceptLanguage) {
      i18n.changeLanguage(checksum.acceptLanguage);
    }
  }, [checksum?.acceptLanguage, i18n]);

  return (
    <>
      <Suspense fallback={<div className="loading"></div>}>
        <Routes>
          {/* Property Tax Route */}
          <Route path="cb/wa/pay-property-tax/:checksum" element={<SessionWrapper />}>
            <Route index element={<Home />} />
            <Route path="paymentSummary" element={<PaymentSummary />} />
            <Route path="assessment" element={<Assessment />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* NOC Certificate Route */}
          <Route path="cb/wa/pay-property-noc-certificate/:checksum" element={<SessionWrapper />}>
            <Route index element={<NocCertificateAssessment />} />
            <Route path="paymentSummary" element={<PaymentSummary />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Assessment Extract Route */}
          <Route path="cb/wa/kmc-pay-property-assessment-extract/:checksum" element={<SessionWrapper />}>
            <Route index element={<Assessment />} />
            <Route path="paymentSummary" element={<PaymentSummary />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* Water tax service */}
          <Route path="cb/wa/water-tax-payment/:checksum" element={<SessionWrapper />}>
            <Route index element={<WaterTaxService />} />
            <Route path="WaterPaymentSummay" element={<WaterPaymentSummay />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
            { /*license fee payment */}
          <Route path="cb/wa/license-fee-payment/:checksum" element={<SessionWrapper />}>
            <Route index element={<LicenseFeePayment />} />
            <Route path="LicenseFeePaymentSummay" element={<LicenseFeePaymentSummay />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          { /* general demand service */}
          <Route path="cb/wa/general-demand-service/:checksum" element={<SessionWrapper />}>
            <Route index element={<GeneralDemandService />} />
            <Route path="GeneralDemandServicePaymentSummay" element={<GeneralDemandServicePaymentSummay />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          { /* grievance status */}
          <Route path="cb/wa/track-grievance-status/:checksum" element={<SessionWrapper />}>
            <Route index element={<GrievanceStatus />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="cb/wa/lodge-grievance/:checksum" element={<SessionWrapper />}>
            <Route index element={<RegisterGrievance />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>

      {/* Toast Notifications */}
      <ToastContainer />
    </>
  );
};

export default KMCRoutes;
